import ContactForm from "../../components/Contact/ContactForm";
import ContactInfo from "../../components/Contact/ContactInfo";

import AdminNavbar from "../AdminNavbar";
import Footer from "../../components/common/Footer";

import "../../assets/css/contactPage.css";

function AdminContactPage() {

    return (

        <section className="customer-contact-page">

            <AdminNavbar />

            {/*=========================================================
                            HERO SECTION
            =========================================================*/}

            <section className="customer-contact-hero">

                <div className="customer-contact-glow customer-contact-glow-one"></div>
                <div className="customer-contact-glow customer-contact-glow-two"></div>

                <span>
                    STORY LINE STUDIOS
                </span>

                <h1>
                    Contact Us
                </h1>

                <p>

                    We'd love to capture your beautiful memories.
                    Contact Story Line Studios to discuss your wedding,
                    pre-wedding, engagement, birthday, or any special
                    celebration with our professional photography team.

                </p>

            </section>

            {/*=========================================================
                            CONTACT SECTION
            =========================================================*/}

            <section className="customer-contact-container">

                <div className="customer-contact-info-wrapper">

                    <ContactInfo />

                </div>

                <div className="customer-contact-form-wrapper">

                    <ContactForm />

                </div>

            </section>

            {/*=========================================================
                            LOCATION
            =========================================================*/}

            <section className="customer-contact-map-section">

                <h2>

                    Visit Our Studio

                </h2>

                <p>

                    We welcome you to visit Story Line Studios and discuss
                    your dream photography session in person.

                </p>

                <div className="customer-contact-map-wrapper">

                    <iframe
                        title="Google Map"
                        src="https://www.google.com/maps?q=Hyderabad&output=embed"
                        loading="lazy"
                        allowFullScreen
                    ></iframe>

                </div>

            </section>

            <Footer />

        </section>

    );

}

export default AdminContactPage;